import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import React, { useState, useRef, useEffect } from "react";
import { AddUserDialog } from "./components/AddUserDialog";
import { EditUserDialog } from "./components/EditUserDialog";
import { api } from "@/api/client";
/*import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";*/
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PaginationComponent } from "@/components/Pagination";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import Header from "@/components/header";
import { UserStateFilterComponent } from "./components/UserStateFilter";
import { toast } from "sonner";
// ag-grid-communityUI开始导入
import type { ColDef, ICellRendererParams } from "ag-grid-community";
// Core CSS
import { AG_GRID_LOCALE_HK } from "@ag-grid-community/locale";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "ag-grid-community"; // 从 ag-grid-community 导入
import { colorSchemeDarkWarm } from "ag-grid-community";
import { useTheme } from "@/contexts/ThemeContext";
import { useTranslation } from "@/locales";
import { envStorage } from "@/utils/envCache";

// 深色主题风格
// const themeDarkWarm = themeQuartz.withPart(colorSchemeDarkWarm);
const themeDarkWarm = themeQuartz.withPart(colorSchemeDarkWarm).withParams({
  backgroundColor: "#1d1d1d",
});

// 定义表格数据类型
interface User {
  uid: string;
  id: number;
  nickname: string;
  email: string;
  role: "USER" | "ADMIN" | "ROOT";
  joinDate: string;
  state: "OK" | "INACTIVE" | "SUSPENDED";
}

// 示例数据

export default function question() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // 判断当前主题是否是深色模式
  // const [isDarkMode, setIsDarkMode] = useState(false);
  const { resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === "dark";
  const [DialogData, setDialogData] = useState({
    title: "",
    description: "",
    confirmText: "",
  });

  // 在组件挂载后设置翻译
  useEffect(() => {
    setDialogData({
      title: t("admin.confirmDelete"),
      description: t("admin.deleteWarning"),
      confirmText: t("common.confirm"),
    });
  }, []);

  // 状态管理
  const [data, setData] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // 排序单独存储
  const [sortParams, setSortParams] = useState<{ sort: string; direction: string } | null>(null);

  // 创建弹窗的引用
  const deleteDialogRef = useRef<any>(null);

  // 分页参数
  const [queryParams, setQueryParams] = useState({
    page: 0,
    size: 30,
  });
  const [total, setTotal] = useState(0); // 总条数

  // 获取列表数据
  const fetchTeamUsers = async (email: any, passedSortParams?: { sort: string; direction: string }) => {
    try {
      setData([]);
      setLoading(true);
      // 如果没有传入排序参数，但有保存的排序参数，则使用保存的
      const finalSortParams = passedSortParams || sortParams;
      let query: any = {
        ...queryParams,
        ...finalSortParams, // 添加排序参数
      };
      if (email) {
        query.email = email;
      }
      // 调用 GET 请求
      const response: any = await api.get("/v1/admin/team/user", {
        params: {
          ...query,
        },
      });
      console.log(response);
      setData(response.content); // 存储接口返回的数据
      setTotal(response.page.totalElements);
    } catch (err) {
      console.error("获取团队用户失败:", err);
      setError(t("admin.loadUsersFailed"));
      toast.error(err);
    } finally {
      setLoading(false); // 无论成功失败，都结束加载状态
    }
  };
  // 分页函数
  const getList = async (page: number, limit: number) => {
    // 更新参数
    setQueryParams({
      ...queryParams,
      page: page,
      size: limit,
    });

    // 调用API获取数据
    console.log(`获取第${page}页，每页${limit}条数据`);
  };
  useEffect(() => {
    // 设置防抖定时器
    const debounceTimer = setTimeout(() => {
      if (searchTerm === "") {
        fetchTeamUsers("");
      } else {
        fetchTeamUsers(searchTerm);
      }
    }, 500); // 500ms 防抖延迟

    // 清除上一次的定时器
    return () => {
      clearTimeout(debounceTimer);
    };
  }, [queryParams.page, queryParams.size, searchTerm, queryParams]); // 空依赖数组表示只在组件挂载时执行一次

  // 在 useEffect 中统一处理过滤器事件
  useEffect(() => {
    // 统一处理所有过滤器变化
    const handleFilterChange = (event: CustomEvent) => {
      const { field, value } = event.detail;
      console.log(`Filter changed - ${field}:`, value);

      // 更新对应的查询参数，保留其他字段
      setQueryParams((prev) => {
        const newParams = { ...prev };

        if (value === undefined || value === null || value === "") {
          delete newParams[field];
        } else {
          (newParams as any)[field] = value;
        }

        return {
          ...newParams,
          page: 0,
        };
      });

      // if (sortParams) {
      //     setTimeout(() => {
      //         getList(searchTerm, sortParams);
      //     }, 0);
      // } else {
      //     setTimeout(() => {
      //         getList(searchTerm);
      //     }, 0);
      // }
    };

    // 添加事件监听器
    window.addEventListener("filterChanged", handleFilterChange as EventListener);

    return () => {
      // 清理事件监听器
      window.removeEventListener("filterChanged", handleFilterChange as EventListener);
    };
  }, [sortParams]);

  // 排序处理函数
  const onSortChanged = (event: any) => {
    const columnState = event.api.getColumnState();
    const sortedColumn = columnState.find((col: any) => col.sort);

    if (sortedColumn) {
      // 当有列被排序时，移除提示图标样式
      const style = document.getElementById("grid-sort-icons");
      if (style) {
        style.innerHTML = `                .ag-header-cell[col-id="createTime"] .ag-header-cell-label::after,
                .ag-header-cell[col-id="joinDate"] .ag-header-cell-label::after {
                    display: none !important;
                }
            `;
      }

      let newSortParam = {};

      // 根据不同的列设置不同的sort参数
      if (sortedColumn.colId === "joinDate") {
        newSortParam = {
          sort: "joinDate",
          direction: sortedColumn.sort === "asc" ? "ASC" : "DESC",
        };
      } else {
        // 其他列使用默认处理
        setSortParams(null);
        fetchTeamUsers(searchTerm);
        return;
      }

      // 保存排序参数
      setSortParams(newSortParam as { sort: string; direction: string });
      // 调用带排序参数的接口
      fetchTeamUsers(searchTerm, newSortParam);
    } else {
      // 当没有列被排序时，恢复提示图标样式
      const style = document.getElementById("grid-sort-icons");
      if (style) {
        style.innerHTML = `                .ag-header-cell[col-id="createTime"] .ag-header-cell-label::after,
                .ag-header-cell[col-id="joinDate"] .ag-header-cell-label::after {
                    content: " ⇅";
                    font-size: 14px;
                    opacity: 0.7;
                    margin-left: 5px;
                }
            `;
      }

      // 清除排序参数
      setSortParams(null);
      // 恢复默认排序
      fetchTeamUsers(searchTerm);
    }
  };

  // 搜索功能
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    // return false
    const value = e.target.value.toLowerCase();
    setQueryParams({
      page: 0,
      size: 30,
    });
    setSearchTerm(value);
    // fetchTeamUsers(value)
  };

  const openDialog = () => {
    deleteDialogRef.current?.open();
    //這裡要拿下id
  };
  // 删除行
  const handleDelete = () => {
    if (DialogData.confirmText === t("admin.copy")) {
      // 复制链接逻辑
      navigator.clipboard.writeText(DialogData.description);
      toast.success(t("admin.copySuccess"));
    } else {
      console.log("执行删除操作...");
    }

    return;
    // setData(data.filter((item) => item.id !== id));
  };
  // 创建弹窗引用
  const addUserDialogRef = useRef<{ open: () => void }>(null);
  const editUserDialogRef = useRef<{ open: (user: User) => void }>(null);
  const statusToggleDialogRef = useRef<{ open: () => void }>(null);
  // 新增成功后的回调
  const handleAddSuccess = (res: any) => {
    console.log(res);
    if (res.type === "LINK") {
      setDialogData({
        title: t("admin.copyInviteLink"),
        description: res.link,
        confirmText: t("admin.copy"),
      });
      openDialog();
    }
    console.log("用户新增成功，刷新列表...");
  };

  // 修改成功后的回调
  const handleEditSuccess = (res: any) => {
    console.log("用户修改成功:", res);
    toast.success(t("admin.userEditSuccess"));
    // 刷新列表
    fetchTeamUsers(searchTerm);
  };

  // 状态切换成功后的回调
  const handleStatusToggleSuccess = (res: any) => {
    console.log("用户状态切换成功:", res);
    toast.success(t("admin.userStatusToggleSuccess"));
    // 刷新列表
    fetchTeamUsers(searchTerm);
  };

  // 处理状态切换
  const handleStatusToggle = async (user: User) => {
    try {
      const newStatus = user.state === "OK" ? "SUSPENDED" : "OK";
      const formData = new URLSearchParams();
      formData.append("uid", user.uid);
      formData.append("state", newStatus);
      const response: any = await api.post("/v1/admin/team/user/state", formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      if (response.success !== false) {
        handleStatusToggleSuccess(response);
      } else {
        toast.error(response.message || t("admin.statusToggleFailed"));
      }
    } catch (error: any) {
      toast.error(error?.data?.msg || t("admin.statusToggleFailedRetry"));
    }
  };

  // 当前要切换状态的用户
  const [currentToggleUser, setCurrentToggleUser] = useState<User | null>(null);
  // 控制状态切换确认弹窗显示
  const [showToggleConfirm, setShowToggleConfirm] = useState(false);

  // 显示状态切换确认弹窗
  const showStatusToggleConfirm = (user: User) => {
    console.log("显示状态切换确认弹窗");
    setCurrentToggleUser(user);
    setShowToggleConfirm(true);
  };

  // 确认状态切换
  const handleConfirmToggleStatus = () => {
    if (currentToggleUser) {
      handleStatusToggle(currentToggleUser);
      setCurrentToggleUser(null);
      setShowToggleConfirm(false);
    }
  };

  // 获取状态标签样式
  const getStatusBadge = (status: User["state"]) => {
    switch (status) {
      case "OK":
        return <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full">正常</span>;
      case "SUSPENDED":
        return <span className="px-2 py-1 text-xs bg-red-100 text-red-800 rounded-full">停用</span>;
      case "INACTIVE":
        return <span className="px-2 py-1 text-xs bg-red-100 text-red-800 rounded-full">未加入</span>;
      default:
        return null;
    }
  };
  // 角色渲染器
  const roleRenderer = (params: ICellRendererParams) => {
    const role = params.value;
    if (role === "USER") {
      return t("admin.editUser.user");
    } else if (role === "ADMIN" || role === "ROOT") {
      return t("admin.editUser.admin");
    }
    return role;
  };
  // 状态渲染器
  const statusRenderer = (params: ICellRendererParams) => {
    const state = params.value;
    if (state === "OK") {
      return t("admin.userStatus.active");
    } else if (state === "INACTIVE") {
      return t("admin.userStatus.inactive");
    } else if (state === "SUSPENDED") {
      return t("admin.userStatus.banned");
    }
    return state;
  };
  // 角色
  const getRole = (role: User["role"]) => {
    switch (role) {
      case "USER":
        return "用戶";
      case "ADMIN":
        return "管理員";
      case "ROOT":
        return "ROOT";
      default:
        return null;
    }
  };

  const sortByCreateTime = (data: any, sortOrder: any) => {
    const sortedData = [...data];
    // 按时间排序
    sortedData.sort((a, b): any => {
      const timeA = new Date(a.joinDate).getTime();
      const timeB = new Date(b.joinDate).getTime();
      // 正序：时间早的排前面；倒序：时间晚的排前面
      return sortOrder === "asc" ? timeA - timeB : timeB - timeA;
    });

    return sortedData;
  };
  const location = useLocation();
  // 当前路由的路径  现在暂时用路径判断，到最终用权限判断显示用户前端界面  还是管理后端的界面
  const currentPath = location.pathname;
  const admin = envStorage.getItem("admin") === "true";
  useEffect(() => {
    //监听标识变化，如果是用户，不给去管理后端
    if (!admin) {
      if (currentPath.indexOf("/admin") !== -1) {
        navigate("/", { replace: true });
      }
    }
  }, [admin]);

  // 监听主题切换
  /*useEffect(() => {
        // 检测当前主题
        const checkThemeMode = () => {
            const themeMode = localStorage.getItem('themeMode');
            console.log(themeMode);

            switch (themeMode) {
                case 'light':
                    setIsDarkMode(false);
                    break;
                case 'dark':
                    setIsDarkMode(true);
                    break;
                case 'system':
                default:
                    const darkMode = document.documentElement.classList.contains('dark') ||
                        window.matchMedia('(prefers-color-scheme: dark)').matches;
                    console.log(darkMode);
                    setIsDarkMode(darkMode);
                    break;
            }
        };

        // 初始检测
        checkThemeMode();

        // 监听 localStorage 变化
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'themeMode') {
                checkThemeMode();
            }
        };

        // 监听系统主题变化
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const mediaQueryListener = (e: MediaQueryListEvent) => {
            // 只有当主题设置为 system 时才响应系统主题变化
            if (localStorage.getItem('themeMode') === 'system' || !localStorage.getItem('themeMode')) {
                setIsDarkMode(e.matches);
            }
        };

        // 监听 DOM class 变化（可能是其他组件改变了主题）
        const observer = new MutationObserver(() => {
            // 只有当主题设置为 system 时才检查 class 变化
            if (localStorage.getItem('themeMode') === 'system' || !localStorage.getItem('themeMode')) {
                const darkMode = document.documentElement.classList.contains('dark');
                setIsDarkMode(darkMode);
            }
        });

        // 如果在同一个页面内修改了主题，需要手动触发检查
        const handleThemeChange = () => {
            console.log('Custom theme change event detected');
            checkThemeMode();
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChange', handleThemeChange);
        mediaQuery.addEventListener('change', mediaQueryListener);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class']
        });

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            mediaQuery.removeEventListener('change', mediaQueryListener);
            window.removeEventListener('themeChange', handleThemeChange);
            observer.disconnect();

        };
    }, []);*/

  const localeText = AG_GRID_LOCALE_HK;
  // 列表配置
  const [columnDefs, setColDefs] = useState<ColDef[]>([]);

  // 使用useEffect来设置列定义，确保翻译已加载
  useEffect(() => {
    setColDefs([
      //floatingFilter: true  高级过滤
      { headerName: t("admin.nickname"), field: "nickname" },
      { headerName: t("admin.email"), field: "email" },
      {
        headerName: t("admin.editUser.roleType"),
        field: "role",
        cellRenderer: (params: ICellRendererParams) => {
          switch (params.value) {
            case "USER":
              return t("admin.editUser.user");
            case "ADMIN":
              return t("admin.editUser.admin");
            case "ROOT":
              return t("user.role.superAdmin");
            default:
              return params.value;
          }
        },
      },
      {
        headerName: t("admin.status"),
        field: "state",
        filter: "UserStateFilter",
        cellRenderer: (params: ICellRendererParams) => {
          const style = params.value === "OK" ? { color: "#00b83d" } : params.value === "INACTIVE" ? { color: "#eb0032" } : { color: "#df860d" };

          return (
            <div
              style={{
                ...style,
                padding: "2px 8px",
                borderRadius: "4px",
              }}
            >
              {params.value === "OK" && <span>{t("admin.userStatus.active")}</span>}
              {params.value === "INACTIVE" && <span>{t("admin.userStatus.inactive")}</span>}
              {params.value === "SUSPENDED" && <span>{t("admin.userStatus.banned")}</span>}
            </div>
          );
        },
        filterValueGetter: (params) => {
          // 根据原始值返回对应的中文显示文本，用于筛选
          switch (params.data.state) {
            case "OK":
              return t("admin.userStatus.active");
            case "INACTIVE":
              return t("admin.userStatus.inactive");
            case "SUSPENDED":
              return t("admin.userStatus.banned");
            default:
              return params.data.state;
          }
        },
      },

      { headerName: t("admin.createTime"), field: "joinDate", sortable: true },
      {
        headerName: t("admin.actions"),
        filter: false,
        cellRenderer: (params: ICellRendererParams) => {
          const user = params.data as User;

          const isRootUser = user.role === "ROOT";
          const isInactiveUser = user.state === "INACTIVE";
          return (
            <div className="flex items-center gap-2">
              <div
                className={`cursor-pointer text-sm px-3 py-1.5 rounded-md transition-colors ${isRootUser ? "opacity-50 cursor-not-allowed text-gray-400" : "dark:text-[#FFFFFF]"}`}
                onClick={isRootUser ? undefined : () => editUserDialogRef.current?.open(user)}
              >
                {t("admin.edit")}
              </div>
              {!isInactiveUser && (
                <div
                  className={`cursor-pointer text-sm px-3 py-1.5 rounded-md transition-colors ${
                    isRootUser ? "opacity-50 cursor-not-allowed text-gray-400" : user.state === "OK" ? "text-red-500 " : "text-green-500 dark:text-green-400"
                  }`}
                  onClick={isRootUser ? undefined : () => showStatusToggleConfirm(user)}
                >
                  {user.state === "OK" ? t("admin.disable") : t("admin.enable")}
                </div>
              )}
            </div>
          );
        },
      },
    ]);
  }, [t]);

  const defaultColDef: ColDef = {
    flex: 1,
    // filter: true,
    // 允许单元格内容被选中
    maxWidth: 300,
    minWidth: 150,
    sortable: false, //是否有排序
    cellStyle: {
      display: "flex",
      alignItems: "center",
      userSelect: "text", // 核心配置：允许文本被选中
      WebkitUserSelect: "text", // 兼容webkit内核浏览器
      MozUserSelect: "text", // 兼容Firefox
    },
  };

  return (
    <div className="flex flex-col pl-4 pr-4 py-12 pt-0 dark:bg-[#1d1d1d] bg-[#ffffff]" style={{ width: "100%", overflow: "auto" }}>
      <style id="grid-sort-icons">
        {`.ag-header-cell[col-id="createTime"] .ag-header-cell-label::after,
            .ag-header-cell[col-id="joinDate"] .ag-header-cell-label::after {
                content: " ⇅";
                font-size: 14px;
                opacity: 0.7;
                margin-left: 5px;
            }`}
      </style>
      <Header title={t("admin.teamUser")} />
      <div className="space-y-4 flex-shrink-0">
        <div className="flex justify-between items-center mx-auto space-y-4 mt-5">
          <h2 className="text-xl mb-0">
            <span className="whitespace-nowrap" style={{ fontSize: "15px" }}>
              {t("admin.email")}:
            </span>
            <Input style={{ display: "inline-block", marginLeft: "10px", height: "32px" }} placeholder={t("admin.emailSearch")} value={searchTerm} onChange={handleSearch} className="w-52 ml-2" />
          </h2>
          <div className="space-x-2">
            <Button onClick={() => addUserDialogRef.current?.open()}>{t("admin.inviteUser")}</Button>
          </div>
        </div>

        <div className="flex-grow ag-theme-alpine" style={{ height: "calc(100vh - 205px)", width: "100%" }}>
          <AgGridReact
            theme={isDarkMode ? themeDarkWarm : themeQuartz} //themeQuartz 默认主题风格
            columnDefs={columnDefs}
            rowData={data}
            defaultColDef={defaultColDef}
            rowHeight={50}
            localeText={localeText}
            components={{
              UserStateFilter: UserStateFilterComponent,
            }}
            onSortChanged={onSortChanged} // 添加排序变化监听
            // 加载状态相关属性
            loadingOverlayComponent={() => (
              <div className="ag-custom-loading">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    flexDirection: "column",
                  }}
                >
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mb-2"></div>
                  <span>{t("common.loading")}</span>
                </div>
              </div>
            )}
            loadingOverlayComponentParams={{
              loadingMessage: t("common.loading"),
            }}
            noRowsOverlayComponent={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  padding: "20px",
                }}
              >
                <div>{t("admin.noData")}</div>
              </div>
            )}
            // 控制何时显示加载状态
            loading={loading}
          />
        </div>
      </div>

      {/* 分页组件 */}
      {total > 0 && (
        <div className="flex-shrink-0 dark:bg-[#1d1d1d] bg-[#ffffff]">
          <PaginationComponent total={total} page={queryParams.page} limit={queryParams.size} pageSizes={[30, 40, 50]} onPagination={getList} prevNextType="icon" />
        </div>
      )}
      {/* 确认弹窗 */}
      <ConfirmDialog ref={deleteDialogRef} title={DialogData.title} description={DialogData.description} confirmText={DialogData.confirmText} onConfirm={handleDelete} />
      {/* 状态切换确认弹窗 */}
      <ConfirmDialog
        open={showToggleConfirm}
        title={currentToggleUser ? (currentToggleUser.state === "OK" ? t("admin.confirmDisableUser") : t("admin.confirmEnableUser")) : ""}
        description={
          currentToggleUser
            ? currentToggleUser.state === "OK"
              ? t("admin.disableUserWarning", { nickname: currentToggleUser.nickname })
              : t("admin.enableUserWarning", { nickname: currentToggleUser.nickname })
            : ""
        }
        confirmText={t("common.confirm")}
        cancelText={t("common.cancel")}
        onConfirm={handleConfirmToggleStatus}
        onCancel={() => setShowToggleConfirm(false)}
      />
      {/* 新增用户弹窗 */}
      <AddUserDialog ref={addUserDialogRef} onSuccess={handleAddSuccess} />
      {/* 修改用户弹窗 */}
      <EditUserDialog ref={editUserDialogRef} onSuccess={handleEditSuccess} />
    </div>
  );
}
